export var AssetListStatus;
(function (AssetListStatus) {
    AssetListStatus[AssetListStatus["NotStarted"] = 1] = "NotStarted";
    AssetListStatus[AssetListStatus["HadLoaderErrors"] = 2] = "HadLoaderErrors";
    AssetListStatus[AssetListStatus["Loading"] = 3] = "Loading";
    AssetListStatus[AssetListStatus["ReadyHasMorePages"] = 4] = "ReadyHasMorePages";
    AssetListStatus[AssetListStatus["ReadyFullyLoaded"] = 5] = "ReadyFullyLoaded";
})(AssetListStatus || (AssetListStatus = {}));
